import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import permissions from "@/config/permissions";
import JwtService from "@/jwt.service";

const user = JwtService.getUser();
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehviour(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
  },
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

//ban đầu luôn phải check xem đã login chưa rồi mới chuyển sang trang home
router.beforeEach(async(to, from, next) => {
  if (JwtService.getToken()){
    if(to.meta.permission){
      let namePermission = permissions[to.meta.permission];
      if(user && user.listPermission && !user.listPermission.includes(namePermission)){
        next('/forbidden') // 403 
      }
    }
    if (to.name == 'login'){
      next('/')
    }
    else {
      next()
    }
  }
  else {
    if (to.name != 'login'){
      next('/login')
    }else {
      next()
    }

  }
})

export default router;
